<template>
    <div
        class="illustration"
        :class="{ 'illustration--xl' : xl , 'illustration--l' : large}"
        :style="`background-image: url(${image})`"
    />
</template>

<script>
    import Vue from 'vue';

    export default Vue.component('Illustration', {
        props: {
            image: {
                type: String,
                default: ''
            },
            xl: {
                type: Boolean,
                default: false
            },
            large: {
                type: Boolean,
                default: false
            }
        }
    });
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/components/Illustration.vue